<template>
  <div>
    <slot />
    <vz-overlay />
  </div>
</template>

<script setup lang="ts">
import { useSeoStore } from '~/stores/seo'
import {useHeaders} from '~/composables/states'
import VzOverlay from '~/components/ui-kit/vz-overlay.vue'

const seoStore = useSeoStore()

const currentUrl = useRequestURL()
const isKZ = currentUrl?.hostname?.endsWith('.kz')

useHead({
  title: seoStore.seo?.seo?.title || 'Транспортная компания «Возовоз»',
  meta: [
    ...(seoStore.seo?.seo?.meta || {}),
    { name: 'yandex-verification', content: isKZ ? 'aba26fc0247e88f1' : '493f85c137146504' },
  ],
  link: seoStore.seo?.seo?.canonical ? [{ rel: 'canonical', href: `${seoStore.seo?.seo?.canonical}` }] : undefined,
})
const headers = useHeaders()
</script>
